module.exports = __webpack_public_path__ + "img/test.48291e77.jpg";